<template>
  <vs-tabs v-model="activeTab" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-home v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-user-check" :label="!isSmallerScreen ? 'Employee' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
<!--        <supplier-manufacturing-employee v-on:notify="notify($event)"/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-grid" :label="!isSmallerScreen ? 'Site Details' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
<!--        <supplier-manufacturing-site-details/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-check" :label="!isSmallerScreen ? 'Quality' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-cloud-drizzle" :label="!isSmallerScreen ? 'Environment' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-check-square" :label="!isSmallerScreen ? 'Ethical' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-shield-off" :label="!isSmallerScreen ? 'Allergens' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'HACCP' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Hygien' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-triangle" :label="!isSmallerScreen ? 'Pest' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-package" :label="!isSmallerScreen ? 'Transport & Storage' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-shield" :label="!isSmallerScreen ? 'Health & Safety' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
    <vs-tab :disabled="isDisable" icon-pack="feather" icon="icon-star" :label="!isSmallerScreen ? 'Authenticity & Traceability' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <!--        <suppliers-manufacture-list/>-->
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  const SupplierRepository = RepositoryFactory.get('supplier');
  import SupplierManufacturingHome from './SupplierManufacturingHome.vue'

  export default {
    components: {
      SupplierManufacturingHome,
    },
    data () {
      return {
        activeTab: 1,
        id: null,
        status: {},
        index: null,
        isDisable: true
      }
    },
    methods: {
      notify() {
        this.activeTab++
      },
      async checkStepFactory() {
        return Object.entries(this.status).forEach(([key, value], index) => {
          if (value === 0) {
            console.log(index)
            return index--
          }
        });
      }
    },
    async mounted() {
      // this.id = this.$route.params.id
      // const {data} = (await supplierRepository.getManufactureSiteStatus(this.id)).data
      // this.status = data
      // const index = await this.checkStepFactory()
      // console.log(index)
    },
    computed: {
      isSmallerScreen () {
        return this.$store.state.windowWidth < 768
      }
    }
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
